export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/404-guy-13f6ffbd92648b7aa0c4129470fbe623.gif";